export const DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID = 'dash-total-active-kpi'

export const DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG = {
  id: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID,
  layout: {
    xl: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 7.5, y: 0, w: 2.25, h: 1.5, static: true },
    lg: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 9, y: 0, w: 3, h: 1.5, static: true },
    md: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 6, y: 0, w: 3, h: 1.5, static: true },
    sm: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 8, y: 0, w: 4, h: 1.5, static: true },
    xs: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 0, y: 1.75, w: 6, h: 1.25, static: true },
    xxs: { i: DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG_ID, x: 0, y: 1.75, w: 6, h: 1, static: true }
  }
}
